<template>
    <div class="wrapper">

        <!-- Loader -->
        <Loader></Loader>

        <!-- Navigation -->
        <Navigation :currency="currency" :locality="locality" :navigation="navigation" :snippets="snippets" :slugs="slugs" :translatable="translatable" v-if="ready && $route.fullPath !== '/'"></Navigation>
        <NavigationHome :currency="currency" :locality="locality" :navigation="navigation" :snippets="snippets" :slugs="slugs" :translatable="translatable" v-if="ready && $route.fullPath === '/'"></NavigationHome>

        <!-- Component -->
        <Component :is="instance"
                   :blocks="blocks"
                   :breadcrumbs="breadcrumbs"
                   :categories="categories"
                   :category="category"
                   :configuration="configuration"
                   :configurations="configurations"
                   :content="content"
                   :currency="currency"
                   :deliveries="deliveries"
                   :locality="locality"
                   :page="page"
                   :pages="pages"
                   :payments="payments"
                   :prices="prices"
                   :products="products"
                   :promotions="promotions"
                   :reservations="reservations"
                   :sequences="sequences"
                   :slug="slug"
                   :snippets="snippets"
                   :siblingsPrev="siblingsPrev"
                   :siblingsNext="siblingsNext"
                   :translations="translations"
                   :translatable="translatable"
                   :widgets="widgets"></Component>

        <!-- Instagram -->
        <section class="section-instagram">
            <img class="d-none d-lg-block" src="/app/images/static/instagram.jpg" :alt="getSnippets('Company')">
            <img class="d-lg-none" src="/app/images/static/instagram-mobile.jpg" :alt="getSnippets('Company')">
        </section>

        <!-- Newsletter -->
        <div class="newsletter" v-if="ready">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-5">
                        <div class="headline">
                            {{ getSnippets('Be the First to Know.') }} <span>{{ getSnippets('Subscribe To Our Newsletter') }}</span>
                            <img src="/app/images/objects/icons/icon-arrow-right-black.svg" :alt="getSnippets('Company')">
                        </div>
                    </div>
                    <div class="col-xl-7">
                        <form class="form-inline" action="https://verozza.us17.list-manage.com/subscribe/post?u=907987c2b19c7098ef642cafc&amp;id=d262574cc2" method="post" name="mc-embedded-subscribe-form" target="_blank">
                            <div class="form-group">
                                <input type="text" class="form-control" name="EMAIL" :placeholder="getSnippets('Enter your e-mail address...')" />
                            </div>
                            <div class="form-group-action">
                                <button type="submit" class="btn btn-newsletters">
                                    <img src="/app/images/objects/icons/icon-arrow-long-right-black.svg" :alt="getSnippets('Company')">
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <Footer :currency="currency" :locality="locality" :navigation="navigation" :snippets="snippets" :slugs="slugs" :translatable="translatable" v-if="ready"></Footer>

        <!-- Cookies -->
        <Cookies :currency="currency" :locality="locality" :snippets="snippets" :translatable="translatable"></Cookies>

    </div>
</template>

<script>
    /* Mixins */
    import { Default } from '../../mixins/Default'

    /* Components */
    import Loader from '../../components/App/Partials/Loader'
    import Navigation from '../../components/App/Partials/Navigation'
    import NavigationHome from '../../components/App/Partials/NavigationHome'
    import Footer from '../../components/App/Partials/Footer'
    import Cookies from '../../components/App/Partials/Cookies'

    /* Logic */
    export default {
        name: 'Index',
        mixins: [Default],
        components: {
            'Loader': Loader,
            'Navigation': Navigation,
            'NavigationHome': NavigationHome,
            'Footer': Footer,
            'Cookies': Cookies
        },
        data: function () {
            return {
                blocks: '',
                breadcrumbs: '',
                categories: '',
                category: '',
                configuration: '',
                configurations: '',
                content: '',
                currency: '',
                deliveries: '',
                documents: '',
                locality: '',
                navigation: '',
                page: '',
                payments: '',
                photos: '',
                prices: '',
                products: '',
                promotions: '',
                pages: '',
                reservations: '',
                settings: '',
                sequences: '',
                slug: '',
                slugs: '',
                snippets: '',
                siblingsPrev: '',
                siblingsNext: '',
                translations: '',
                translatable: '',
                widgets: '',
                ready: '',
                meta: {
                    title: '',
                    author: '',
                    keywords: '',
                    description: '',
                    facebook_title: '',
                    facebook_description: '',
                    locality: '',
                    image: '',
                    url: '',
                }
            }
        },
        methods: {
            setExpiration: function () {
                let current = new Date()
                let expiration = this.$store.state.expiration
                if (expiration === null) {
                    this.$store.dispatch('setExpiration', new Date())
                } else {
                    let convertCurrent = this.Moment(current)
                    let convertExpiration = this.Moment(expiration)
                    let duration = this.Moment.duration(convertCurrent.diff(convertExpiration))
                    let minutes = duration.asMinutes()
                    if (minutes > 180) {
                        this.$store.dispatch('reinitializeData')
                    }
                }
            },
            fetchItems: function () {
                this.Axios.get('/api/v1/init', {
                    params: {
                        slug: this.$route.params.pathMatch,
                        page: this.$route.query.page,
                        isPreview: this.$route.query.isPreview
                    }
                }).then(response => {
                    this.blocks = response.data.content.data.blocks
                    this.breadcrumbs = response.data.content.data.breadcrumbs
                    this.categories = response.data.content.data.categories
                    this.category = response.data.content.data.category
                    this.configuration = response.data.content.data.configuration
                    this.configurations = response.data.content.data.configurations
                    this.content = response.data.content.data.content
                    this.currency = response.data.content.data.currency
                    this.deliveries = response.data.content.data.deliveries
                    this.documents = response.data.content.data.documents
                    this.locality = response.data.content.data.locality
                    this.navigation = response.data.content.data.navigation
                    this.page = response.data.content.data.page
                    this.payments = response.data.content.data.payments
                    this.photos = response.data.content.data.photos
                    this.prices = response.data.content.data.prices
                    this.products = response.data.content.data.products
                    this.promotions = response.data.content.data.promotions
                    this.pages = response.data.content.data.pages
                    this.reservations = response.data.content.data.reservations
                    this.settings = response.data.content.data.settings
                    this.sequences = response.data.content.data.sequences
                    this.slug = response.data.content.data.slug
                    this.slugs = response.data.content.data.slugs
                    this.snippets = response.data.content.data.snippets
                    this.siblingsPrev = response.data.content.data.siblingsPrev
                    this.siblingsNext = response.data.content.data.siblingsNext
                    this.translations = response.data.content.data.translations
                    this.translatable = response.data.content.data.translatable
                    this.widgets = response.data.content.data.widgets

                    /* Process Storage */
                    this.$store.dispatch('setPhotos', this.photos)
                    this.$store.dispatch('setDocuments', this.documents)
                }).catch(() => {
                    this.blocks = ''
                    this.breadcrumbs = ''
                    this.categories = ''
                    this.category = ''
                    this.configuration = ''
                    this.configurations = ''
                    this.content = ''
                    this.currency = ''
                    this.deliveries = ''
                    this.documents = ''
                    this.locality = ''
                    this.navigation = ''
                    this.page = ''
                    this.payments = ''
                    this.photos = ''
                    this.prices = ''
                    this.products = ''
                    this.promotions = ''
                    this.pages = ''
                    this.reservations = ''
                    this.settings = ''
                    this.sequences = ''
                    this.slug = ''
                    this.slugs = ''
                    this.snippets = ''
                    this.siblingsPrev = ''
                    this.siblingsNext = ''
                    this.translations = ''
                    this.translatable = ''
                    this.widgets = ''

                    /* Process Storage */
                    this.$store.dispatch('setPhotos', [])
                    this.$store.dispatch('setDocuments', [])
                }).finally(() => {
                    this.setMeta()
                    this.setExpiration()
                })
            }
        },
        created: function () {
            this.initialize()
            this.fetchItems()
            this.setOverflow()
            this.setWindowTop()
        },
        metaInfo: function () {
            return {
                title: this.meta.title,
                htmlAttrs: {
                    lang: this.meta.locality,
                    amp: false
                },
                meta: [
                    { name: 'author', content: this.meta.author },
                    { name: 'keywords', content: this.meta.keywords },
                    { name: 'description', content: this.meta.description },

                    { property: 'og:title', content:this.meta.facebook_title },
                    { property: 'og:site_name', content: this.meta.author },
                    { property: 'og:type', content: 'website' },
                    { property: 'og:url', content: this.meta.url },
                    { property: 'og:image', content: this.meta.image },
                    { property: 'og:description', content: this.meta.facebook_description },

                    { name: 'twitter:card', content: 'summary' },
                    { name: 'twitter:site', content: this.meta.url },
                    { name: 'twitter:title', content: this.meta.title },
                    { name: 'twitter:description', content: this.meta.description },

                    { itemprop: 'name', content: this.meta.title },
                    { itemprop: 'description', content: this.meta.description },
                    { itemprop: 'image', content: this.meta.image }
                ],
                link: [
                    { rel: 'canonical', href: this.meta.url }
                ]
            }
        },
        computed: {
            instance () {
                if (this.$route.query.isPreview === 'true') {
                    switch (this.page) {
                        case null:
                            this.ready = false
                            return () => import('../../components/App/Errors/404/Index')
                        default:
                            this.ready = true
                            let category = this.Lodash.upperFirst(this.Lodash.camelCase(this.category.title))
                            let multiplicity = parseInt(this.page.multiplicity)
                            switch (multiplicity) {
                                case 0:
                                    multiplicity = 'Sequence'
                                    break
                                default:
                                    multiplicity = 'Category'
                            }
                            return () => import(`../../components/App/Categories/${category}/${multiplicity}/Index`)
                    }
                } else {
                    switch (parseInt(this.getSettings('Maintenance mode'))) {
                        case 1:
                            this.ready = false
                            return () => import('../../components/App/Errors/503/Index')
                        default:
                            switch (this.page) {
                                case null:
                                    this.ready = false
                                    return () => import('../../components/App/Errors/404/Index')
                                default:
                                    this.ready = true
                                    let category = this.Lodash.upperFirst(this.Lodash.camelCase(this.category.title))
                                    let multiplicity = parseInt(this.page.multiplicity)
                                    switch (multiplicity) {
                                        case 0:
                                            multiplicity = 'Sequence'
                                            break
                                        default:
                                            multiplicity = 'Category'
                                    }
                                    return () => import(`../../components/App/Categories/${category}/${multiplicity}/Index`)
                            }
                    }
                }
            }
        }
    }
</script>
